import React, { useState } from 'react';
import PropTypes from 'prop-types';
import useResponsive from 'hooks/useResponsive';

function InformationIcon({ color, hoverColor, size }) {
  const [currentColor, setCurrentColor] = useState(color);
  const isMobile = useResponsive();

  const responsiveSize = size || (isMobile ? 20 : 14);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={responsiveSize}
      height={responsiveSize}
      className="information-icon"
      viewBox="0 0 14 14"
      fill="none"
      style={{
        flexShrink: '0',
        transition: 'stroke 0.3s ease',
      }}
      onMouseEnter={() => setCurrentColor(hoverColor)}
      onMouseLeave={() => setCurrentColor(color)}
    >
      <g clipPath="url(#clip0_299_4054)">
        <path
          d="M7.00002 12.8332C10.2217 12.8332 12.8334 10.2215 12.8334 6.99984C12.8334 3.77818 10.2217 1.1665 7.00002 1.1665C3.77836 1.1665 1.16669 3.77818 1.16669 6.99984C1.16669 10.2215 3.77836 12.8332 7.00002 12.8332Z"
          stroke={currentColor}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M7 9.33333V7" stroke={currentColor} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7 4.6665H7.00583" stroke={currentColor} strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_299_4054">
          <rect width={responsiveSize} height={responsiveSize} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

InformationIcon.propTypes = {
  color: PropTypes.string,
  hoverColor: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

InformationIcon.defaultProps = {
  color: 'var(--color-sky-gray7)',
  hoverColor: 'var(--color-blue-normal)',
  size: null,
};

export default InformationIcon;



// WEBPACK FOOTER //
// ./assets/icons/information.js